import { render, staticRenderFns } from "./accountingAccount.vue?vue&type=template&id=65f7c187&"
import script from "./accountingAccount.vue?vue&type=script&lang=js&"
export * from "./accountingAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports